<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Información del Organismo">
          <b-form>
            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim="$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>


            <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="inactivo"
                  v-model="inactivo"
                  value= true
                  unchecked-value= false>
                  Inactivo
              </b-form-checkbox>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, maxLength, helpers } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'impuestoOrganismo/getField',
  mutationType: 'impuestoOrganismo/updateField',
});

export default {
  name: 'ImpuestoOrganismoABM',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      nombreValido: null,
      nombreInvalidoMsj: '',
      // observacionesValidas: null,
      // observacionesInvalidasMsj: '',

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'nombre',
      // 'observaciones',
      'inactivo',
    ])
  },  
  created() {
    let impuestoOrganismoId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        impuestoOrganismoId = this.$route.params.id
      }
    }

    this.showSpinner();
    this.$store.dispatch('impuestoOrganismo/inicializar', impuestoOrganismoId)
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      const vm = this;
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj= 'Debe ingresar el nombre del organismo';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre solo puede contener hasta 50 caracteres';
          } 
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }
        
      // if (campo == 'observaciones' || validarTodos) {
      //   if (this.$v.observaciones.$error) {
      //     this.observacionesValidas = false;
      //     if (!this.$v.observaciones.maxLength) {
      //       this.observacionesInvalidasMsj = 'Las observaciones solo pueden contener hasta 5000 caracteres';
      //     }      
      //   } else {
      //     this.observacionesValidas = null;
      //     this.observacionesInvalidasMsj = '';
      //   }
      // }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;
      let save = true;

      this.$v.$touch();

      this.impuestosOrganismo = true;

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('impuestoOrganismo/save')
            .then(()  => this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        }
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    goList() {
      this.$router.push({ name: "ImpuestosOrganismos" });
    },
  },
  validations() {
    return {
      nombre: {
        required,
        maxLength: maxLength(50)
      },
      // observaciones: {
      //   maxLength: maxLength(5000)
      // },
    }
  },  
}
</script>

<style>
</style>
